import { useState, useEffect } from 'react';

const useQueue = () => {
  const [queueItems, setQueueItems] = useState(undefined);
  const [contracts, setContracts] = useState(undefined);
  const [update, shouldUpdate] = useState(undefined);

  useEffect(() => {
    const fetchQueueItems = async () => {
      try {
        const { contract, userAddress } = contracts;
        const queue = parseInt(await contract.methods.getMyQueue().call({ from: userAddress }));

        return queue;
      } catch (error) {
        console.log('error: ', error);
      }
    };

    if (contracts !== undefined) {
      fetchQueueItems().then((response) => {
        setQueueItems(response);
      });
    }
  }, [contracts, update]);

  return [queueItems, setContracts, shouldUpdate];
};

export const revealNFT = async (contract, userAddress, nftType) => {
  try {
    const item = await contract.methods.revealNFT(nftType).send({ from: userAddress});

    return item;
  } catch (error) {
    return error;
  }
};

export default useQueue;

// const result = [];
// await Promise.all(
//   queue.map(async (id) => {
//     const status = await contract.methods.revealNFT(id).call({ from: userAddress });
//     result.push(status);
//   })
// );

// return queue.reduce((acc, cur) => {
//   let index = 1;
//   acc.push({
//     queueId: cur,
//     status: result[index],
//   });

//   index++;

//   return acc;
// }, []);
